import { useDMFriendsListQuery, useDMRoomListQuery } from 'src/hooks/useDirectMessageQuery';

const useUseDMFirstTime = () => {
  const { data: { cursor, follows = [] } = {}, isLoading: isFriendsLoading } =
    useDMFriendsListQuery();
  const { data: roomList = [], isLoading: isRoomListLoading } = useDMRoomListQuery();

  const isLoading = isFriendsLoading || isRoomListLoading;
  const isFirstTime = !isLoading && cursor == null && follows.length === 0 && roomList.length === 0;

  return { isFirstTime, isLoading };
};

export default useUseDMFirstTime;
